import { useEffect, useState } from 'react';
import { safeStorage } from '@/app/utils/client';

const LOCAL_STORAGE_SUBMIT_COUNT_KEY = 'VIDU_CHAR2VIDEO_SUBMIT_COUNT';
const SUBMIT_COUNT_THRESHOLD = 2; // 用户参考生生成2次以后，会变成状态2（教学视频 hover 播放按钮出现）

// 用于选择参考生工具入口布局
export const useLayoutManager = (key = LOCAL_STORAGE_SUBMIT_COUNT_KEY) => {
  const [useAlternativeLayout, setUseAlternativeLayout] = useState<boolean>(false);

  const updateSubmitCount = () => {
    if (useAlternativeLayout) return;

    const currentCount = Number(safeStorage.getItem(key) || '0');
    const newCount = currentCount + 1;
    safeStorage.setItem(key, newCount.toString());

    if (newCount >= SUBMIT_COUNT_THRESHOLD) {
      setUseAlternativeLayout(true);
    }
  };

  useEffect(() => {
    const submitCount = Number(safeStorage.getItem(key) || '0');
    if (submitCount >= SUBMIT_COUNT_THRESHOLD) {
      setUseAlternativeLayout(true);
    }
  }, []);

  return {
    useAlternativeLayout,
    updateSubmitCount,
  };
};
